import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import subProductOfferingDetailService from "services/Setup/Organization/subProductOfferingDetailService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  statusRequest: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  subProductOfferingDetailList: [],
};

export const getsubproductOfferingDetail = createAsyncThunk(
  "subProductOffering/getsubproductOfferingDetail",
  async (data, { rejectWithValue }) => {
    // console.log("getsubproductOfferingDetaillist tess", data);
    try {
      const response =
        await subProductOfferingDetailService.getsubproductOfferingDetail(data);
      // console.log("getsubproductOfferingDetaillist", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getsubproductOfferinglist error", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const getsubproductOfferingDetailSerch = createAsyncThunk(
  "subProductOffering/getsubproductOfferingDetailSerch",
  async (data, { rejectWithValue }) => {
    console.log("getsubproductOfferingDetailSerchlist tess", data);
    try {
      const response =
        await subProductOfferingDetailService.getsubproductOfferingDetailSerch(
          data
        );
      console.log("getsubproductOfferingDetailSerchlist", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getsubproductOfferinglist error", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const posSubProductOfferingSliceDetail = createAsyncThunk(
  "subProductOffering/posSubProductOfferingSliceDetail",
  async (data, { rejectWithValue }) => {
    console.log("posSubProductOfferingSliceDetail", data);
    try {
      const response =
        await subProductOfferingDetailService.postSubProductOfferingDetail(
          data
        );
      console.log("posSubProductOfferingSliceDetail", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const putSubProductOfferingSliceDetail = createAsyncThunk(
  "subProductOffering/putSubProductOfferingSliceDetail",
  async (data, { rejectWithValue }) => {
    console.log("putSubProductOfferingSliceDetail", data);
    try {
      const response =
        await subProductOfferingDetailService.putSubProductOfferingSliceDetail(
          data
        );
      console.log("putSubProductOfferingSliceDetail", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const subProductOfferingSliceDetailApproval = createAsyncThunk(
  "subProductOffering/subProductOfferingSliceDetailApproval",
  async (data, { rejectWithValue }) => {
    console.log("subProductOfferingSliceDetailApproval", data);
    try {
      const response =
        await subProductOfferingDetailService.getsubproductOfferingDetailApproval(
          data
        );
      console.log("🚀 ~ subProductOfferingDetailServiceresponse:", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const productOfferingDetailReturn = createAsyncThunk(
  "subProductOffering/productOfferingDetailReturn",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await subProductOfferingDetailService.productOfferingDetailReturn(data);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const subproductOfferingDetailApproval = createAsyncThunk(
  "subProductOffering/subproductOfferingDetailApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await subProductOfferingDetailService.subproductOfferingDetailApproval(
          data
        );
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const ProductOfferingDetailReject = createAsyncThunk(
  "subProductOffering/ProductOfferingDetailReject",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await subProductOfferingDetailService.ProductOfferingDetailReject(data);
      console.log("ProductOfferingDetailReject", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const ProductOfferingDetailRequest = createAsyncThunk(
  "subProductOffering/ProductOfferingDetailRequest",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ ProductOfferingDetailRequestdata:", data);
    try {
      const response =
        await subProductOfferingDetailService.ProductOfferingDetailRequest(
          data
        );
      console.log("ProductOfferingDetailRequest", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deleteProductOfferingDeleteCharges = createAsyncThunk(
  "subProductOffering/deleteProductOfferingDeleteCharges",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ deleteProductOfferingDeleteChargesdata:", data);
    try {
      const response =
        await subProductOfferingDetailService.deleteProductOfferingDeleteCharges(
          data
        );
      console.log("deleteProductOfferingDeleteCharges", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const uploadProductOfferingDetail = createAsyncThunk(
  "subProductOffering/uploadProductOfferingDetail",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~uploadProductOfferingDetail data:", data);
    try {
      const response =
        await subProductOfferingDetailService.uploadProductOfferingDetail(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const subProductOfferingDetailSlice = createSlice({
  name: "subProductOfferingDetail",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    falseMessage: (state) => {
      state.message = "";
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //lis sub offering

      .addCase(getsubproductOfferingDetail.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductOfferingDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.subProductOfferingDetailList = action.payload.data.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getsubproductOfferingDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //lis sub offering search

      .addCase(getsubproductOfferingDetailSerch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductOfferingDetailSerch.fulfilled, (state, action) => {
        state.loading = false;
        state.subProductOfferingDetailList = action.payload.data.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getsubproductOfferingDetailSerch.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //lis sub offering detail approval

      .addCase(subProductOfferingSliceDetailApproval.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(
        subProductOfferingSliceDetailApproval.fulfilled,
        (state, action) => {
          state.loading = false;
          state.subProductOfferingDetailList = action.payload.data.data;
          state.getCount = action.payload.data.count;
        }
      )
      .addCase(
        subProductOfferingSliceDetailApproval.rejected,
        (state, action) => {
          state.loading = false;
          state.result = action.payload;
          state.showMessage = true;
        }
      )
      //Do Approval
      .addCase(subproductOfferingDetailApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(subproductOfferingDetailApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(subproductOfferingDetailApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(productOfferingDetailReturn.pending, (state) => {
        state.loading = true;
      })
      .addCase(productOfferingDetailReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(productOfferingDetailReturn.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Reject
      .addCase(ProductOfferingDetailReject.pending, (state) => {
        state.loading = true;
      })
      .addCase(ProductOfferingDetailReject.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(ProductOfferingDetailReject.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Reject
      .addCase(ProductOfferingDetailRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(ProductOfferingDetailRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(ProductOfferingDetailRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //post
      .addCase(posSubProductOfferingSliceDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(posSubProductOfferingSliceDetail.fulfilled, (state, action) => {
        console.log('posSubProductOfferingSliceDetail',action);
        
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
        // statusRequest
      })
      .addCase(posSubProductOfferingSliceDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //put
      .addCase(putSubProductOfferingSliceDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(putSubProductOfferingSliceDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(putSubProductOfferingSliceDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //detaile
      .addCase(deleteProductOfferingDeleteCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        deleteProductOfferingDeleteCharges.fulfilled,
        (state, action) => {
          state.loading = false;
          state.redirect = "/";
          state.result = action.payload;
          state.message = "ok";
        }
      )
      .addCase(deleteProductOfferingDeleteCharges.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //upload sub product offering detail
      .addCase(uploadProductOfferingDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadProductOfferingDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(uploadProductOfferingDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, falseMessage, hideNotification, showLoading } =
  subProductOfferingDetailSlice.actions;

export default subProductOfferingDetailSlice.reducer;
